import { SESSION_LIMIT_MAX, SESSION_LIMIT_MIN, SESSION_LIMIT_UNLIMITED_LABEL } from '../admin/sessionLimit';

/**
 * 동시 세션 상한 입력 칸(§15) — 숫자 칸 하나, **비우면 무제한**. 사용자 편집·su 조직 화면 공용.
 * 값 해석·범위 검사는 `parseSessionLimit`(저장할 때) — 이 칸은 글자만 들고 있다(빈 칸과 0 을 구분해야 해서 문자열).
 *
 * @param value 입력 글자(빈 문자열 = 무제한)
 * @param onEnter Enter 로 저장 · onEscape Esc 로 취소(행 안 편집에서 다른 칸과 같은 손버릇)
 */
export function SessionLimitInput({
  value,
  onChange,
  onEnter,
  onEscape,
  autoFocus,
  label = '동시 세션 상한',
}: {
  value: string;
  onChange: (v: string) => void;
  onEnter?: () => void;
  onEscape?: () => void;
  autoFocus?: boolean;
  label?: string;
}) {
  return (
    <input
      type="number"
      inputMode="numeric"
      min={SESSION_LIMIT_MIN}
      max={SESSION_LIMIT_MAX}
      step={1}
      value={value}
      autoFocus={autoFocus}
      placeholder={SESSION_LIMIT_UNLIMITED_LABEL}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onEnter?.();
        if (e.key === 'Escape') onEscape?.();
      }}
      aria-label={label}
      style={{ width: 110 }}
    />
  );
}
